import type { CfiFinding, CfiRating } from '~/data/hooks/useCfi';

const EMPTY: Record<CfiRating, number> = {
  favorable: 0,
  neutral: 0,
  unfavorable: 0,
  not_applicable: 0,
};

// Counts findings by their *final* rating (consultant override if present,
// otherwise the agent's). Skips findings the consultant dropped from the
// report. Mirrors `_aggregate_final_ratings` on the API but runs against
// in-memory state so the editor's dashboard updates without a refetch.
export const finalCounts = (findings: CfiFinding[]): Record<CfiRating, number> => {
  const counts = { ...EMPTY };
  for (const f of findings) {
    if (f.excludedFromReport) continue;
    // consultantRating wins when set; otherwise fall back to the agent's.
    // agentRating is null for consultant-custom findings, but those always
    // carry a consultantRating, so `rating` is never null in practice — guard
    // anyway so a malformed row can't index `counts` with null.
    const rating = f.consultantRating ?? f.agentRating;
    if (rating == null) continue;
    counts[rating] = (counts[rating] ?? 0) + 1;
  }
  return counts;
};
